module.exports = __webpack_public_path__ + "img/68.2bf18e52.jpg";